<!-- =========================================================================================
  File Name: VerticalSidebar.vue
  Description: Sidebar Component
  Component Name: VerticalSidebar
========================================================================================== -->

<template>
  <section class="lg:relative absolute grid justify-center items-start place-content-center" title="">
    <div
      class="py-6 flex flex-col justify-start fixed bg-white shadow-sm rounded-lg gap-8 w-24 place-content-center justify-self-center"
      style="height: 93%">
      <router-link class="flex relative items-center w-full justify-center cursor-pointer" to="/user/dashboard">
        <img class="w-auto h-12 object-cover" src="@/assets/images/new-sidebar/icon.svg" />
      </router-link>

      <span class="w-auto bg-slate-100 mx-4 rounded-full my-0 xl:my-0" style="padding: 0.5px 0px"></span>

      <div class="flex relative items-center w-full justify-center flex-col xl:gap-6 gap-4">
        <vx-tooltip :text="$t('orgDashboard.userDashboard.sidebar.dashboard')" position="right" class="flex flex-col w-full">
          <router-link to="/user/dashboard"
            class="grid place-content-center justify-center grid-flow-col py-3 items-center relative overflow-hidden sidebar__item"
            :class="activeRoute === 'user-home' ? 'sidebar__item__active' : ''">
            <span class="absolute w-full h-full bg-primary rounded __hover" style="right: 95%"></span>

            <div class="flex justify-between items-center gap-3 w-fit">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                class="absolute __hover">
                <path
                  d="M21.743 12.331L12.743 2.331C12.364 1.909 11.636 1.909 11.257 2.331L2.25698 12.331C2.12767 12.4747 2.04277 12.6527 2.01255 12.8436C1.98232 13.0345 2.00807 13.2301 2.08668 13.4067C2.16529 13.5833 2.29339 13.7333 2.45548 13.8386C2.61757 13.9439 2.8067 13.9999 2.99998 14H4.99998V21C4.99998 21.2652 5.10534 21.5196 5.29288 21.7071C5.48041 21.8946 5.73477 22 5.99998 22H18C18.2652 22 18.5196 21.8946 18.7071 21.7071C18.8946 21.5196 19 21.2652 19 21V14H21C21.1936 14.0008 21.3834 13.9453 21.546 13.8401C21.7087 13.735 21.8372 13.5848 21.916 13.4079C21.9947 13.231 22.0203 13.0349 21.9896 12.8437C21.9589 12.6525 21.8732 12.4744 21.743 12.331ZM12 16C11.2043 16 10.4413 15.6839 9.87866 15.1213C9.31605 14.5587 8.99998 13.7956 8.99998 13C8.99998 12.2043 9.31605 11.4413 9.87866 10.8787C10.4413 10.3161 11.2043 10 12 10C12.7956 10 13.5587 10.3161 14.1213 10.8787C14.6839 11.4413 15 12.2043 15 13C15 13.7956 14.6839 14.5587 14.1213 15.1213C13.5587 15.6839 12.7956 16 12 16Z"
                  fill="#FBB603" />
                <rect x="5" y="10" width="14" height="7" fill="#FBB603" />
                <circle cx="12" cy="17" r="3" fill="#737171" />
              </svg>

              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                  d="M21.743 12.3311L12.743 2.33115C12.364 1.90915 11.636 1.90915 11.257 2.33115L2.25698 12.3311C2.12767 12.4748 2.04277 12.6529 2.01255 12.8438C1.98232 13.0347 2.00807 13.2303 2.08668 13.4068C2.16529 13.5834 2.29339 13.7334 2.45548 13.8387C2.61757 13.944 2.8067 14.0001 2.99998 14.0001H4.99998V21.0001C4.99998 21.2654 5.10534 21.5197 5.29288 21.7073C5.48041 21.8948 5.73477 22.0001 5.99998 22.0001H18C18.2652 22.0001 18.5196 21.8948 18.7071 21.7073C18.8946 21.5197 19 21.2654 19 21.0001V14.0001H21C21.1936 14.001 21.3834 13.9454 21.546 13.8403C21.7087 13.7352 21.8372 13.585 21.916 13.408C21.9947 13.2311 22.0203 13.0351 21.9896 12.8439C21.9589 12.6527 21.8732 12.4745 21.743 12.3311ZM12 16.0001C11.2043 16.0001 10.4413 15.6841 9.87866 15.1215C9.31605 14.5589 8.99998 13.7958 8.99998 13.0001C8.99998 12.2045 9.31605 11.4414 9.87866 10.8788C10.4413 10.3162 11.2043 10.0001 12 10.0001C12.7956 10.0001 13.5587 10.3162 14.1213 10.8788C14.6839 11.4414 15 12.2045 15 13.0001C15 13.7958 14.6839 14.5589 14.1213 15.1215C13.5587 15.6841 12.7956 16.0001 12 16.0001Z"
                  fill="#737171" />
                <rect x="5" y="10" width="14" height="7" fill="#737171" />
                <circle cx="12" cy="17" r="3" fill="#FBB603" />
              </svg>

              <span class="text-base font-medium text-neutral-800 toggle">Dashboard</span>
            </div>

            <div class="rotate-90 opacity-30 toggle">
              <img class="w-3" src="@/assets/images/new-sidebar/arrow.svg" />
            </div>
          </router-link>
        </vx-tooltip>   
        
        <vx-tooltip :text="$t('orgDashboard.userDashboard.sidebar.boards')" position="right" class="flex flex-col w-full">
          <router-link to="/user/boards" :class="activeRoute === 'user-boards' ? 'sidebar__item__active' : ''
            "
            class="grid place-content-center justify-center grid-flow-col py-3 items-center relative overflow-hidden sidebar__item">
            <span class="absolute w-full h-full bg-primary rounded __hover" style="right: 95%"></span>

            <div class="flex justify-between items-center gap-3 w-fit">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                class="absolute __hover">
                <rect x="3" y="3" width="8" height="8" rx="2" fill="#F2C244" />
                <rect x="3" y="13" width="8" height="8" rx="2" fill="#F2C244" />
                <rect x="13" y="3" width="8" height="8" rx="2" fill="#737171" />
                <rect x="13" y="13" width="8" height="8" rx="2" fill="#F2C244" />
              </svg>

              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <rect x="3" y="3" width="8" height="8" rx="2" fill="#737171" />
                <rect x="3" y="13" width="8" height="8" rx="2" fill="#737171" />
                <rect x="13" y="3" width="8" height="8" rx="2" fill="#FBB603" />
                <rect x="13" y="13" width="8" height="8" rx="2" fill="#737171" />
              </svg>

              <span class="text-base font-medium text-neutral-800 toggle">Dashboard</span>
            </div>

            <div class="rotate-90 opacity-30 toggle">
              <img class="w-3" src="@/assets/images/new-sidebar/arrow.svg" />
            </div>
          </router-link>
        </vx-tooltip>

        <vx-tooltip :text="$t('orgDashboard.userDashboard.sidebar.notifications')" position="right" class="flex flex-col w-full">
          <router-link to="/user/notifications" :class="activeRoute === 'user-notifications'
              ? 'sidebar__item__active'
              : ''
            "
            class="grid place-content-center justify-center grid-flow-col py-3 items-center relative overflow-hidden sidebar__item">
            <span class="absolute w-full h-full bg-primary rounded __hover" style="right: 95%"></span>

            <div class="flex justify-between items-center gap-3 w-fit">
              
              <!-- WRAPPED ICONS IN A RELATIVE DIV TO ALIGN RED DOT -->
              <div class="relative w-6 h-6 flex-shrink-0 flex items-center justify-center">
                
                <!-- Hover Bell Icon -->
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" class="absolute __hover">
                  <path d="M12 22C12.6193 22.0008 13.2235 21.8086 13.7285 21.4502C14.2335 21.0917 14.6143 20.5849 14.818 20H9.182C9.38566 20.5849 9.76648 21.0917 10.2715 21.4502C10.7765 21.8086 11.3807 22.0008 12 22ZM19 14.586V10C19 6.783 16.815 4.073 13.855 3.258C13.562 2.52 12.846 2 12 2C11.154 2 10.438 2.52 10.145 3.258C7.185 4.074 5 6.783 5 10V14.586L3.293 16.293C3.19996 16.3857 3.12617 16.4959 3.07589 16.6172C3.0256 16.7386 2.99981 16.8687 3 17V18C3 18.2652 3.10536 18.5196 3.29289 18.7071C3.48043 18.8946 3.73478 19 4 19H20C20.2652 19 20.5196 18.8946 20.7071 18.7071C20.8946 18.5196 21 18.2652 21 18V17C21.0002 16.8687 20.9744 16.7386 20.9241 16.6172C20.8738 16.4959 20.8 16.3857 20.707 16.293L19 14.586Z" fill="#F2C244" />
                  <path d="M12 22C12.6193 22.0008 13.2235 21.8086 13.7285 21.4502C14.2335 21.0917 14.6143 20.5849 14.818 20H9.182C9.38566 20.5849 9.76648 21.0917 10.2715 21.4502C10.7765 21.8086 11.3807 22.0008 12 22Z" fill="#737171" />
                </svg>

                <!-- Regular Bell Icon -->
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M12 22C12.6193 22.0008 13.2235 21.8086 13.7285 21.4502C14.2335 21.0917 14.6143 20.5849 14.818 20H9.182C9.38566 20.5849 9.76648 21.0917 10.2715 21.4502C10.7765 21.8086 11.3807 22.0008 12 22ZM19 14.586V10C19 6.783 16.815 4.073 13.855 3.258C13.562 2.52 12.846 2 12 2C11.154 2 10.438 2.52 10.145 3.258C7.185 4.074 5 6.783 5 10V14.586L3.293 16.293C3.19996 16.3857 3.12617 16.4959 3.07589 16.6172C3.0256 16.7386 2.99981 16.8687 3 17V18C3 18.2652 3.10536 18.5196 3.29289 18.7071C3.48043 18.8946 3.73478 19 4 19H20C20.2652 19 20.5196 18.8946 20.7071 18.7071C20.8946 18.5196 21 18.2652 21 18V17C21.0002 16.8687 20.9744 16.7386 20.9241 16.6172C20.8738 16.4959 20.8 16.3857 20.707 16.293L19 14.586Z" fill="#737171" />
                  <path d="M11.9977 22C12.617 22.0008 13.2211 21.8086 13.7262 21.4502C14.2312 21.0917 14.612 20.5849 14.8157 20H9.17969C9.38335 20.5849 9.76416 21.0917 10.2692 21.4502C10.7742 21.8086 11.3784 22.0008 11.9977 22Z" fill="#FBB603" />
                </svg>

                <!-- THE RED DOT (v-if tied to your console logs) -->
                <span v-if="hasUnreadNotifications" 
                      class="absolute bg-red-500 rounded-full border-2 border-white" 
                      style="width: 12px; height: 12px; top: -2px; right: -2px; z-index: 50;">
                </span>

              </div>

              <span class="text-base font-medium text-neutral-800 toggle">Dashboard</span>
            </div>

            <div class="rotate-90 opacity-30 toggle">
              <img class="w-3" src="@/assets/images/new-sidebar/arrow.svg" />
            </div>
          </router-link>
        </vx-tooltip>

        <!-- ADMIN INVITES TAB -->
        <!-- <vx-tooltip text="Admin Invites" position="right" class="flex flex-col w-full">
          <router-link to="/user/admin-invites" :class="activeRoute === 'admin-invites' ? 'sidebar__item__active' : ''"
            class="grid place-content-center justify-center grid-flow-col py-3 items-center relative overflow-hidden sidebar__item">
            <span class="absolute w-full h-full bg-primary rounded __hover" style="right: 95%"></span>

            <div class="flex justify-between items-center gap-3 w-fit">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" class="absolute __hover">
                <path d="M20 6H16V4C16 2.895 15.105 2 14 2H10C8.895 2 8 2.895 8 4V6H4C2.895 6 2 6.895 2 8V19C2 20.105 2.895 21 4 21H20C21.105 21 22 20.105 22 19V8C22 6.895 21.105 6 20 6ZM10 4H14V6H10V4Z" fill="#FBB603" />
              </svg>

              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M20 6H16V4C16 2.895 15.105 2 14 2H10C8.895 2 8 2.895 8 4V6H4C2.895 6 2 6.895 2 8V19C2 20.105 2.895 21 4 21H20C21.105 21 22 20.105 22 19V8C22 6.895 21.105 6 20 6ZM10 4H14V6H10V4Z" :fill="activeRoute === 'admin-invites' ? '#FBB603' : '#737171'" />
              </svg>

              <span class="text-base font-medium text-neutral-800 toggle">Admin Invites</span>
            </div>

            <div class="rotate-90 opacity-30 toggle">
              <img class="w-3" src="@/assets/images/new-sidebar/arrow.svg" />
            </div>
          </router-link>
        </vx-tooltip> -->

        <vx-tooltip text="Career Predictor" position="right" class="flex flex-col w-full">
          <router-link
            to="/user/career-path"
            :class="activeRoute === 'user-career-path' ? 'sidebar__item__active' : ''"
            class="grid place-content-center justify-center grid-flow-col py-3 items-center relative overflow-hidden sidebar__item"
          >
            <span
              class="absolute w-full h-full bg-primary rounded __hover"
              style="right: 95%"
            ></span>

            <div class="flex justify-between items-center gap-3 w-fit">
              
              <!-- Active/Hover Compass Icon (Yellow) -->
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                class="absolute __hover"
              >
                <!-- Outer Circle -->
                <circle cx="12" cy="12" r="10" fill="#F2C046" />

                <!-- Inner Compass -->
                <path
                  d="M16.19 7.81L14.06 14.06L7.81 16.19L9.94 9.94L16.19 7.81ZM12 10.9C11.39 10.9 10.9 11.39 10.9 12C10.9 12.61 11.39 13.1 12 13.1C12.61 13.1 13.1 12.61 13.1 12C13.1 11.39 12.61 10.9 12 10.9Z"
                  fill="#737171"
                />
              </svg>

              <!-- Default Compass Icon -->
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <!-- Outer Circle -->
                <circle
                  cx="12"
                  cy="12"
                  r="10"
                  :fill="activeRoute === 'user-career-path' ? '#737171' : '#737171'"
                />

                <!-- Inner Compass -->
                <path
                  d="M16.19 7.81L14.06 14.06L7.81 16.19L9.94 9.94L16.19 7.81ZM12 10.9C11.39 10.9 10.9 11.39 10.9 12C10.9 12.61 11.39 13.1 12 13.1C12.61 13.1 13.1 12.61 13.1 12C13.1 11.39 12.61 10.9 12 10.9Z"
                  :fill="activeRoute === 'user-career-path' ? '#FBB603' : '#FBB603'"
                />
              </svg>

              <span class="text-base font-medium text-neutral-800 toggle">
                Predictor
              </span>
            </div>

            <div class="rotate-90 opacity-30 toggle">
              <img class="w-3" src="@/assets/images/new-sidebar/arrow.svg" />
            </div>
          </router-link>
        </vx-tooltip>

        <!-- <vx-tooltip text="Compensation" position="right" class="flex flex-col w-full">
          <router-link
            to="/user/compensation"
            :class="activeRoute === 'user-compensation' ? 'sidebar__item__active' : ''"
            class="grid place-content-center justify-center grid-flow-col py-3 items-center relative overflow-hidden sidebar__item"
          >
            <span class="absolute w-full h-full bg-primary rounded __hover" style="right: 95%"></span>
            <div class="flex justify-between items-center gap-3 w-fit">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" class="absolute __hover">
                <path d="M20 4H4C2.89 4 2.01 4.89 2.01 6L2 18C2 19.11 2.89 20 4 20H20C21.11 20 22 19.11 22 18V6C22 4.89 21.11 4 20 4ZM20 18H4V12H20V18ZM20 8H4V6H20V8Z" fill="#FBB603"/>
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M20 4H4C2.89 4 2.01 4.89 2.01 6L2 18C2 19.11 2.89 20 4 20H20C21.11 20 22 19.11 22 18V6C22 4.89 21.11 4 20 4ZM20 18H4V12H20V18ZM20 8H4V6H20V8Z" fill="#737171"/>
              </svg>
              <span class="text-base font-medium text-neutral-800 toggle">Pay</span>
            </div>
          </router-link>
        </vx-tooltip> -->

        <vx-tooltip :text="$t('orgDashboard.userDashboard.sidebar.reviews')" position="right" class="hidden flex-col w-full">
          <router-link to="/reviews" :class="activeRoute === 'user-reviews' ? 'sidebar__item__active' : ''
            "
            class="grid place-content-center justify-center grid-flow-col py-3 items-center relative overflow-hidden sidebar__item">
            <span class="absolute w-full h-full bg-primary rounded __hover" style="right: 95%"></span>

            <div class="flex justify-between items-center gap-3 w-fit">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                class="absolute __hover">
                fill="none">
                <path
                  d="M8 12.0518C9.995 12.0518 11.5 10.5468 11.5 8.55176C11.5 6.55676 9.995 5.05176 8 5.05176C6.005 5.05176 4.5 6.55676 4.5 8.55176C4.5 10.5468 6.005 12.0518 8 12.0518ZM9 12.9998H7C4.243 12.9998 2 15.2428 2 17.9998V18.9998H14V17.9998C14 15.2428 11.757 12.9998 9 12.9998ZM20.294 8.29176L15.994 12.5838L14.702 11.2918L13.288 12.7058L15.994 15.4098L21.706 9.70776L20.294 8.29176Z"
                  fill="#F2C046" />
                <path
                  d="M20.294 8.29199L15.994 12.584L14.702 11.292L13.288 12.706L15.994 15.41L21.706 9.70799L20.294 8.29199Z"
                  fill="#737171" />
              </svg>

              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                  d="M8 12.0518C9.995 12.0518 11.5 10.5468 11.5 8.55176C11.5 6.55676 9.995 5.05176 8 5.05176C6.005 5.05176 4.5 6.55676 4.5 8.55176C4.5 10.5468 6.005 12.0518 8 12.0518ZM9 12.9998H7C4.243 12.9998 2 15.2428 2 17.9998V18.9998H14V17.9998C14 15.2428 11.757 12.9998 9 12.9998ZM20.294 8.29176L15.994 12.5838L14.702 11.2918L13.288 12.7058L15.994 15.4098L21.706 9.70776L20.294 8.29176Z"
                  fill="#737171" />
                <path
                  d="M20.294 8.29199L15.994 12.584L14.702 11.292L13.288 12.706L15.994 15.41L21.706 9.70799L20.294 8.29199Z"
                  fill="#737171" />
              </svg>

              <span class="text-base font-medium text-neutral-800 toggle">Dashboard</span>
            </div>

            <div class="rotate-90 opacity-30 toggle">
              <img class="w-3" src="@/assets/images/new-sidebar/arrow.svg" />
            </div>
          </router-link>
        </vx-tooltip>

        <vx-tooltip :text="$t('orgDashboard.userDashboard.sidebar.community')" position="right" class="flex-col w-full">
          <router-link to="/user/community" :class="activeRoute === 'user-community' ? 'sidebar__item__active' : ''
            "
            class="grid place-content-center justify-center grid-flow-col py-3 items-center relative overflow-hidden sidebar__item">
            <span class="absolute w-full h-full bg-primary rounded __hover" style="right: 95%"></span>

            <div class="flex justify-between items-center gap-3 w-fit">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                class="absolute __hover">
                fill="none">
                <path
                  d="M21 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V7H2V9H4V11H2V13H4V15H2V17H4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H21C21.2652 22 21.5196 21.8946 21.7071 21.7071C21.8946 21.5196 22 21.2652 22 21V3C22 2.73478 21.8946 2.48043 21.7071 2.29289C21.5196 2.10536 21.2652 2 21 2ZM13 4.999C14.648 4.999 16 6.35 16 7.999C15.9971 8.79385 15.6801 9.55533 15.1182 10.1175C14.5562 10.6796 13.7948 10.9968 13 11C11.353 11 10 9.647 10 7.999C10 6.35 11.353 4.999 13 4.999ZM19 18H7V17.25C7 15.031 9.705 12.75 13 12.75C16.295 12.75 19 15.031 19 17.25V18Z"
                  fill="#F2C046" />
                <path d="M2 7H4V9V11V13V15V17H2V15H4V13H2V11H4V9H2V7Z" fill="#F2C046" />
              </svg>

              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                  d="M21 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V7H2V9H4V11H2V13H4V15H2V17H4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H21C21.2652 22 21.5196 21.8946 21.7071 21.7071C21.8946 21.5196 22 21.2652 22 21V3C22 2.73478 21.8946 2.48043 21.7071 2.29289C21.5196 2.10536 21.2652 2 21 2ZM13 4.999C14.648 4.999 16 6.35 16 7.999C15.9971 8.79385 15.6801 9.55533 15.1182 10.1175C14.5562 10.6796 13.7948 10.9968 13 11C11.353 11 10 9.647 10 7.999C10 6.35 11.353 4.999 13 4.999ZM19 18H7V17.25C7 15.031 9.705 12.75 13 12.75C16.295 12.75 19 15.031 19 17.25V18Z"
                  fill="#737171" />
                <path d="M2 7H4V9V11V13V15V17H2V15H4V13H2V11H4V9H2V7Z" fill="#737171" />
              </svg>

              <span class="text-base font-medium text-neutral-800 toggle">Dashboard</span>
            </div>

            <div class="rotate-90 opacity-30 toggle">
              <img class="w-3" src="@/assets/images/new-sidebar/arrow.svg" />
            </div>
          </router-link>
        </vx-tooltip>

        <!-- <vx-tooltip :text="$t('orgDashboard.userDashboard.sidebar.wallet')" position="right" class="flex flex-col w-full">
          <router-link to="/user/wallet" :class="activeRoute === 'user-wallet' ? 'sidebar__item__active' : ''
            "
            class="grid place-content-center justify-center grid-flow-col py-3 items-center relative overflow-hidden sidebar__item">
            <span class="absolute w-full h-full bg-primary rounded __hover" style="right: 95%"></span>

            <div class="flex justify-between items-center gap-3 w-fit">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                class="absolute __hover">
                fill="none">
                <path d="M14 9H22V15H14V9Z" fill="#737171" />
                <path
                  d="M20 3H5C3.346 3 2 4.346 2 6V18C2 19.654 3.346 21 5 21H20C21.103 21 22 20.103 22 19V17H14C12.897 17 12 16.103 12 15V9C12 7.897 12.897 7 14 7H22V5C22 3.897 21.103 3 20 3Z"
                  fill="#F2C046" />
              </svg>

              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M14 9H22V15H14V9Z" fill="#FBB603" />
                <path
                  d="M20 3H5C3.346 3 2 4.346 2 6V18C2 19.654 3.346 21 5 21H20C21.103 21 22 20.103 22 19V17H14C12.897 17 12 16.103 12 15V9C12 7.897 12.897 7 14 7H22V5C22 3.897 21.103 3 20 3Z"
                  fill="#737171" />
              </svg>

              <span class="text-base font-medium text-neutral-800 toggle">Dashboard</span>
            </div>

            <div class="rotate-90 opacity-30 toggle">
              <img class="w-3" src="@/assets/images/new-sidebar/arrow.svg" />
            </div>
          </router-link>
        </vx-tooltip> -->

        <vx-tooltip text="Apps Store" position="right" class="hidden flex-col w-full">
          <router-link to="/apps" :class="activeRoute === 'user-apps' ? 'sidebar__item__active' : ''"
            class="grid place-content-center justify-center grid-flow-col py-3 items-center relative overflow-hidden sidebar__item">
            <span class="absolute w-full h-full bg-primary rounded __hover" style="right: 95%"></span>

            <div class="flex justify-between items-center gap-3 w-fit">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                class="absolute __hover">
                fill="none">
                <path
                  d="M18 9C19.6569 9 21 7.65685 21 6C21 4.34315 19.6569 3 18 3C16.3431 3 15 4.34315 15 6C15 7.65685 16.3431 9 18 9Z"
                  fill="#737171" />
                <path
                  d="M13 6C13 5.288 13.153 4.613 13.422 4H6C4.897 4 4 4.897 4 6V18C4 19.103 4.897 20 6 20H18C19.103 20 20 19.103 20 18V10.578C19.3698 10.8559 18.6887 10.9997 18 11C16.6739 11 15.4021 10.4732 14.4645 9.53553C13.5268 8.59785 13 7.32608 13 6Z"
                  fill="#F2C046" />
              </svg>

              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                  d="M18 9C19.6569 9 21 7.65685 21 6C21 4.34315 19.6569 3 18 3C16.3431 3 15 4.34315 15 6C15 7.65685 16.3431 9 18 9Z"
                  fill="#737171" />
                <path
                  d="M13 6C13 5.288 13.153 4.613 13.422 4H6C4.897 4 4 4.897 4 6V18C4 19.103 4.897 20 6 20H18C19.103 20 20 19.103 20 18V10.578C19.3698 10.8559 18.6887 10.9997 18 11C16.6739 11 15.4021 10.4732 14.4645 9.53553C13.5268 8.59785 13 7.32608 13 6Z"
                  fill="#737171" />
              </svg>

              <span class="text-base font-medium text-neutral-800 toggle">Dashboard</span>
            </div>

            <div class="rotate-90 opacity-30 toggle">
              <img class="w-3" src="@/assets/images/new-sidebar/arrow.svg" />
            </div>
          </router-link>
        </vx-tooltip>
      </div>

      <span class="w-auto bg-slate-100 mx-4 rounded-full xl:my-0 my-0" style="padding: 0.5px 0px"></span>

      <div class="flex relative items-center w-full justify-end flex-col gap-8 h-full">
        <vx-tooltip text="Settings" position="right" class="flex flex-col w-full">
          <router-link to="/user/settings" :class="activeRoute === 'user-settings' ? 'sidebar__item__active' : ''"
            class="grid place-content-center justify-center grid-flow-col py-3 items-center relative overflow-hidden sidebar__item">
            <span class="absolute w-full h-full bg-primary rounded __hover" style="right: 95%"></span>

            <div class="flex justify-between items-center gap-3 w-fit">
              
              <!-- Active/Hover Settings Icon (Yellow) -->
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="absolute __hover">
                <!-- Grey Inner Circle -->
                <circle cx="12" cy="12" r="3.5" fill="#737171" />
                <!-- Yellow Gear Parts -->
                <path d="M19.14 12.94C19.18 12.64 19.2 12.33 19.2 12C19.2 11.67 19.18 11.36 19.14 11.06L21.16 9.48C21.34 9.34 21.39 9.08 21.28 8.88L19.36 5.56C19.25 5.36 19 5.29 18.8 5.36L16.42 6.32C15.93 5.94 15.39 5.63 14.81 5.39L14.45 2.85C14.41 2.62 14.21 2.44 13.98 2.44H10.02C9.79 2.44 9.59 2.62 9.55 2.85L9.19 5.39C8.61 5.63 8.07 5.94 7.58 6.32L5.2 5.36C5 5.28 4.75 5.36 4.64 5.56L2.72 8.88C2.61 9.08 2.66 9.34 2.84 9.48L4.86 11.06C4.82 11.36 4.8 11.67 4.8 12C4.8 12.33 4.82 12.64 4.86 12.94L2.84 14.52C2.66 14.66 2.61 14.92 2.72 15.12L4.64 18.44C4.75 18.64 5 18.71 5.2 18.64L7.58 17.68C8.07 18.06 8.61 18.37 9.19 18.61L9.55 21.15C9.59 21.38 9.79 21.56 10.02 21.56H13.98C14.21 21.56 14.41 21.38 14.45 21.15L14.81 18.61C15.39 18.37 15.93 18.06 16.42 17.68L18.8 18.64C19 18.72 19.25 18.64 19.36 18.44L21.28 15.12C21.39 14.92 21.34 14.66 21.16 14.52L19.14 12.94ZM12 15.5C10.07 15.5 8.5 13.93 8.5 12C8.5 10.07 10.07 8.5 12 8.5C13.93 8.5 15.5 10.07 15.5 12C15.5 13.93 13.93 15.5 12 15.5Z" fill="#FBB603"/>
              </svg>

              <!-- Default State (Grey Gear, Yellow Circle) -->
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="__regular">
                <!-- Yellow Inner Circle -->
                <circle cx="12" cy="12" r="3.5" fill="#FBB603" />
                <!-- Grey Gear Parts -->
                <path d="M19.14 12.94C19.18 12.64 19.2 12.33 19.2 12C19.2 11.67 19.18 11.36 19.14 11.06L21.16 9.48C21.34 9.34 21.39 9.08 21.28 8.88L19.36 5.56C19.25 5.36 19 5.29 18.8 5.36L16.42 6.32C15.93 5.94 15.39 5.63 14.81 5.39L14.45 2.85C14.41 2.62 14.21 2.44 13.98 2.44H10.02C9.79 2.44 9.59 2.62 9.55 2.85L9.19 5.39C8.61 5.63 8.07 5.94 7.58 6.32L5.2 5.36C5 5.28 4.75 5.36 4.64 5.56L2.72 8.88C2.61 9.08 2.66 9.34 2.84 9.48L4.86 11.06C4.82 11.36 4.8 11.67 4.8 12C4.8 12.33 4.82 12.64 4.86 12.94L2.84 14.52C2.66 14.66 2.61 14.92 2.72 15.12L4.64 18.44C4.75 18.64 5 18.71 5.2 18.64L7.58 17.68C8.07 18.06 8.61 18.37 9.19 18.61L9.55 21.15C9.59 21.38 9.79 21.56 10.02 21.56H13.98C14.21 21.56 14.41 21.38 14.45 21.15L14.81 18.61C15.39 18.37 15.93 18.06 16.42 17.68L18.8 18.64C19 18.72 19.25 18.64 19.36 18.44L21.28 15.12C21.39 14.92 21.34 14.66 21.16 14.52L19.14 12.94ZM12 15.5C10.07 15.5 8.5 13.93 8.5 12C8.5 10.07 10.07 8.5 12 8.5C13.93 8.5 15.5 10.07 15.5 12C15.5 13.93 13.93 15.5 12 15.5Z" fill="#737171"/>
              </svg>

              <span class="text-base font-medium text-neutral-800 toggle">Settings</span>
            </div>

            <div class="rotate-90 opacity-30 toggle">
              <img class="w-3" src="@/assets/images/new-sidebar/arrow.svg" />
            </div>
          </router-link>
        </vx-tooltip>
        <vx-tooltip text="Getting Started" position="right" class="flex flex-col w-full">
          <router-link to="/user/getting-started" :class="activeRoute === 'user-getting-started' ? 'sidebar__item__active' : ''"
            class="grid place-content-center justify-center grid-flow-col py-3 items-center relative overflow-hidden sidebar__item">
            <span class="absolute w-full h-full bg-primary rounded __hover" style="right: 95%"></span>

            <div class="flex justify-between items-center gap-3 w-fit">
              
              <!-- Active/Hover Help Icon (Yellow) -->
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" class="absolute __hover">
                <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 19H11V17H13V19ZM15.07 11.25L14.17 12.17C13.45 12.9 13 13.5 13 15H11V14.5C11 13.4 11.45 12.4 12.17 11.67L13.41 10.41C13.78 10.05 14 9.55 14 9C14 7.9 13.1 7 12 7C10.9 7 10 7.9 10 9H8C8 6.79 9.79 5 12 5C14.21 5 16 6.79 16 9C16 9.88 15.64 10.68 15.07 11.25Z" fill="#FBB603"/>
              </svg>
              
              <!-- Default State Help Icon (Grey/Yellow dynamic) -->
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 19H11V17H13V19ZM15.07 11.25L14.17 12.17C13.45 12.9 13 13.5 13 15H11V14.5C11 13.4 11.45 12.4 12.17 11.67L13.41 10.41C13.78 10.05 14 9.55 14 9C14 7.9 13.1 7 12 7C10.9 7 10 7.9 10 9H8C8 6.79 9.79 5 12 5C14.21 5 16 6.79 16 9C16 9.88 15.64 10.68 15.07 11.25Z" :fill="activeRoute === 'user-getting-started' ? '#FBB603' : '#737171'"/>
              </svg>

              <span class="text-base font-medium text-neutral-800 toggle">Start</span>
            </div>
            
            <div class="rotate-90 opacity-30 toggle">
              <img class="w-3" src="@/assets/images/new-sidebar/arrow.svg" />
            </div>
          </router-link>
        </vx-tooltip>
      </div>

      <div class="hidden relative items-center w-full justify-center flex-col gap-8">
        <div class="grid place-content-center justify-center grid-flow-col items-center gap-4">
          <div class="flex justify-between items-center p-2 bg-green-400 rounded-lg gap-4 w-fit">
            <img class="w-4" src="@/assets/images/new-sidebar/icon.svg" />
          </div>

          <a class="text-base font-normal text-slate-500 bg-none w-fit rounded-lg toggle">Board Name</a>
        </div>

        <div class="grid place-content-center justify-center grid-flow-col items-center gap-4">
          <div class="flex justify-between items-center p-2 bg-blue-400 rounded-lg gap-4 w-fit">
            <img class="w-4" src="@/assets/images/new-sidebar/icon.svg" />
          </div>

          <a class="text-base font-normal text-slate-500 bg-none w-fit rounded-lg toggle">Board Name</a>
        </div>

        <div class="grid place-content-center justify-center grid-flow-col items-center gap-4">
          <div class="flex justify-between items-center p-2 bg-purple-400 rounded-lg gap-4 w-fit">
            <img class="w-4" src="@/assets/images/new-sidebar/icon.svg" />
          </div>

          <a class="text-base font-normal text-slate-500 bg-none w-fit rounded-lg toggle">Board Name</a>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "v-nav-menu",
  components: {},
  props: {
    title: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      hasUnreadNotifications: false,
      lastSeenCount: parseInt(localStorage.getItem('lastSeenNotificationCount') || '0'),
      chatCount: 0,
      coachCount: 0,
      notificationPollInterval: null,
      debounceTimer: null,
    };
  },
  computed: {
    activeRoute() {
      return this.$route.name ? this.$route.name.toLowerCase() : '';
    },
    adminInviteCount() {
      const myOrgs = this.$store?.state?.organization?.myOrganizations?.subOrgs || [];
      return myOrgs.filter(org => org.status !== 'active' && org.status !== 'DEACTIVATED').length;
    },
    totalNotifications() {
      return this.adminInviteCount + this.chatCount + this.coachCount;
    }
  },
  watch: {
    totalNotifications: {
      immediate: true,
      handler(newTotal) {
        if (this.debounceTimer) clearTimeout(this.debounceTimer);
        
        this.debounceTimer = setTimeout(() => {
          this.evaluateRedDot(newTotal);
        }, 2000); 
      }
    },
    $route: {
      immediate: true,
      handler(to) {
        if (to.path.includes('/user/notifications')) {
          this.hasUnreadNotifications = false;
          this.lastSeenCount = this.totalNotifications;
          localStorage.setItem('lastSeenNotificationCount', this.totalNotifications);
        }
        this.fetchExternalCounts();
      }
    }
  },
  created() {
    const authState = this.$store?.state?.auth;
    const user = authState ? authState.user : null;

    if (user && user._id) {
      if (this.isUserLoggedIn || (authState && authState.isUserLoggedIn)) {
        this.$store.dispatch("boards/fetchUserBoardData", user._id).catch(() => {});
      }
      
      this.$store.dispatch("users/fetchUser", user._id).then((res) => {
          if (res?.data?.personality?.length > 0) {
             this.$store.commit("editor/SET_PERSONALITY", res.data.personality[0]);
          }
      }).catch(() => {});

      this.fetchExternalCounts();
      
      this.notificationPollInterval = setInterval(() => {
        this.fetchExternalCounts();
      }, 10000); 
    }
  },
  beforeDestroy() {
    if (this.notificationPollInterval) clearInterval(this.notificationPollInterval);
    if (this.debounceTimer) clearTimeout(this.debounceTimer);
  },
  methods: {
    evaluateRedDot(newTotal) {
      if (isNaN(this.lastSeenCount)) this.lastSeenCount = 0;
      const isOnNotificationsPage = this.$route.path.includes('/user/notifications');
      
      console.log(`🔴 [Red Dot Check] Stable Total: ${newTotal} | Last Seen: ${this.lastSeenCount}`);

      if (isOnNotificationsPage) {
        this.hasUnreadNotifications = false;
        this.lastSeenCount = newTotal;
        localStorage.setItem('lastSeenNotificationCount', newTotal);
      } else {
        if (newTotal > this.lastSeenCount) {
          console.log("✅ SHOWING DOT! New notification arrived.");
          this.hasUnreadNotifications = true; 
        } else if (newTotal < this.lastSeenCount) {
          
          // --- THE ULTIMATE GLITCH PROTECTOR ---
          // If total suddenly drops to 0, it's a Vuex state wipe during page load. Ignore it!
          if (newTotal === 0) {
            console.log("⚠️ Ignored sudden drop to 0 (Vuex loading glitch blocked).");
          } else {
            // It's a genuine partial drop (e.g., you had 14 invites and accepted 1 -> now 13). Safe to sync!
            this.lastSeenCount = newTotal;
            localStorage.setItem('lastSeenNotificationCount', newTotal);
          }
          
        }
      }
    },

    async fetchExternalCounts() {
      try {
        const authState = this.$store?.state?.auth;
        const userId = authState?.user?._id;
        const userEmail = authState?.user?.email;
        const token = localStorage.getItem('accessToken') || localStorage.getItem('feathers-jwt');

        if (!userId || !token) return;
        const headers = { 'Authorization': `Bearer ${token}` };
        const API_URL = process.env.VUE_APP_API_URL;

        try {
          await this.$store.dispatch("organization/fetchAllMyOrganizations", { email: userEmail, userId });
        } catch (e) { }

        try {
          const chatRes = await fetch(`${API_URL}/api/users/${userId}/notifications`, { headers });
          if (chatRes.ok) {
            const chatData = await chatRes.json();
            this.chatCount = (chatData.data || []).filter(n => !n.is_read || n.is_read === 0 || n.is_read === false).length;
          }
        } catch (e) { }
        
        try {
          const coachRes = await fetch(`${API_URL}/api/v2/users/${userId}/coach-invitations`, { headers });
          if (coachRes.ok) {
            const coachData = await coachRes.json();
            this.coachCount = (coachData.data || []).length;
          }
        } catch (e) { }
        
      } catch (err) {
        console.error("Failed to fetch notification counts:", err);
      }
    }
  }
};
</script>

<style lang="scss">
.sidebar__item {
  cursor: pointer;

  .__hover {
    transition: all 0.1s ease-in;
    opacity: 0;
  }
}

.sidebar__item:hover {
  .__hover {
    opacity: 1;
  }
}

.sidebar__item__active {
  cursor: pointer;

  .__hover {
    transition: all 0.1s ease-in;
    opacity: 1;
  }
}

.toggle {
  display: none;
}

.active path {
  stroke: #ffcc00 !important;
}
</style>
